import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary, ButtonSecondary } from '@spotify-internal/encore-web';
import { useT } from 'client/i18n/hooks/useT';

export function ConfirmationModal({
  onCancel,
  onConfirm,
  action,
}: {
  onCancel: () => void;
  onConfirm: () => void;
  action?: 'delete' | 'end';
}) {
  const t = useT();
  if (!action) return null;
  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={onCancel}
      aria-labelledby="interactive-confirmation-poll-title"
    >
      <Modal.Title id="interactive-confirmation-poll-title">
        {t(
          'EpisodeEditorPublish.InteractivePoll.ConfirmationModal.Title',
          'Are you sure you want to {action} this poll?',
          'Interactive poll action confirmation modal title',
          { action }
        )}
      </Modal.Title>
      <Modal.Body>
        {action === 'delete'
          ? t(
              'EpisodeEditorPublish.InteractivePoll.ConfirmationModal.DeleteActionMessage',
              "If you delete this poll, we won't be able to recover it.",
              'Interactive poll delete confirmation modal message'
            )
          : t(
              'EpisodeEditorPublish.InteractivePoll.ConfirmationModal.UnpublishActionMessage',
              'You can always republish this poll at a later date.',
              'Interactive poll unpublish confirmation modal message'
            )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonSecondary onClick={onCancel}>
          {t('Button.Cancel', 'Cancel', 'Cancel button text')}
        </ButtonSecondary>
        <ButtonPrimary onClick={onConfirm}>
          {t(
            'EpisodeEditorPublish.InteractivePoll.ConfirmationModal.ConfirmActionButtonLabel',
            'Yes, {action} this poll',
            'Interactive poll action confirmation button text',
            { action }
          )}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}
